import script from "./ppointsSettle.vue?vue&type=script&setup=true&lang=js"
export * from "./ppointsSettle.vue?vue&type=script&setup=true&lang=js"

import "./ppointsSettle.vue?vue&type=style&index=0&id=3240aa5c&lang=scss"

const __exports__ = script;

export default __exports__